// extracted by mini-css-extract-plugin
export default {"root":"CheckboxInput_root__hVQIv","input":"CheckboxInput_input__9x2Qi"};